import PropTypes from 'prop-types';

import Span from '../../../../../components/Span';
import Icon from '../../../../../components/Icon';
import useTranslation from '../../../../../hooks/useTranslation';

function ThemeToggler({ skin, setSkin }) {
  const { t } = useTranslation();
  if (skin === 'dark') {
    return (
      <Span title={t('Turn on Theme')}>
        <Icon
          icon="fa-brightness"
          className="ficon"
          onClick={() => setSkin('light')}
        />
      </Span>
    );
  }
  return (
    <Span title={t('Turn on Theme')}>
      <Icon
        icon="fa-moon"
        className="ficon"
        onClick={() => setSkin('dark')}
      />
    </Span>
  );
}

ThemeToggler.propTypes = {
  skin: PropTypes.string.isRequired,
  setSkin: PropTypes.func.isRequired
};
export default ThemeToggler;
